<template>
  <div>
    <div id="app ">
      <div style="display: flex; justify-content: space-between;" class="mt-4">
        <!-- <v-col cols="11"> -->
        <Breadcrumb class="row justify-content-center mt-4" />
        <!-- </v-col> -->
        <span v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </span>
      </div>
    </div>
    <v-data-table
      ref="theDataTable"
      v-model="selectedItems"
      :headers="headersData"
      :items="operatorsData"
      item-key="user_id"
      item-value="user_name"
      :search="search"
      :items-per-page="5"
      select-strategy="single"
      return-object
      :mobile-breakpoint="0"
      item-selectable="selectable"
      show-select
      @pagination="pagination = $event"
    >
      <v-spacer></v-spacer>
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <!-- <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="50"
            offset-x
          > -->
          <v-dialog v-model="dialog" max-width="400px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                :disabled="selectedItems.length === 0 ? true : false"
                color="primary"
                @click="deleteItem()"
              >
                mdi-delete
              </v-icon>
            </template>

            <v-card class="pt-4">
              <v-card-text
                style="font-weight: bolder; font-size: large; "
                text-color="primary"
                :disabled="selectedItems.length === 0 ? true : false"
              >
                Are you sure you want to delete the user?
              </v-card-text>
              <v-card-actions class="pb-5">
                <v-spacer></v-spacer>
                <v-btn small rounded color="#FE000c" @click="dialog = false">
                  <v-icon left class="icon-white">icon-cancel</v-icon>
                  <span style="color: white">Cancel</span>
                </v-btn>

                <v-btn small rounded color="primary" @click="save()">
                  <v-icon left>icon-availability</v-icon>
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- </v-menu> -->
        </v-toolbar>
      </template>

      <!--date picker chnage -->
      <template v-slot:item.deactivate_date="{ item }">
        <v-menu
          v-model="item.datePickerVisible"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }" style="width: 20px;">
            <div style="display: flex;">
              <v-icon>
                mdi-calendar
              </v-icon>
              <v-text-field
                v-bind="attrs"
                v-on="on"
                style="min-width: 15vh;max-width: 15vh;"
                v-model="item.deactivate_date"
                :label="item.deactivate_date === null ? 'select Date' : 'Date'"
                readonly
              ></v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="item.deactivate_date"
            @input="item.datePickerVisible = false"
          ></v-date-picker>
        </v-menu>
      </template>
      <!-- change  for date picker  -->
      <!--  -->
      <template v-slot:item.saveDeactivateDateButton="{ item }">
        <v-icon
          color="primary"
          @click="saveDeactivateDate(item)"
          :disabled="item.deactivate_date === null ? true : false"
        >
          mdi-content-save
        </v-icon>
      </template>
      <!--  -->
    </v-data-table>
    <div id="sucessAlert">
      <v-alert outlined type="success" text> Data Saved successfully. </v-alert>
    </div>
    <div id="errorAlert">
      <v-alert outlined type="warning" prominent border="left">
        Error while saving the data.
      </v-alert>
    </div>
  </div>
</template>
<script>
import LoaderProgress from "../components/progressLoader";
import Breadcrumb from "../components/breadcrumbs.vue";
import axios from "axios";
import router from "../router";
export default {
  components: {
    Breadcrumb,
    LoaderProgress,
  },
  data: () => ({
    selectedHeader: [
      {
        text: "User Name",
        value: "user_name",
      },
      {
        text: "Deactivate Dates",
        value: "deactivate_date",
      },
    ],
    dialog: false,
    showLoader: false,
    headersData: [],
    search: "",
    operatorsData: [],
    pagination: null,
    menu: false,
    selectedItems: [],
  }),
  created() {
    this.setGridData();
  },
  methods: {
    deleteItem() {
      this.menu = true;
    },

    setGridData: function() {
      this.headersData = [
        {
          text: "User Name",
          value: "user_name",
          align: "start",
        },
        // {
        //   text: "Email",
        //   value: "email",
        // },

        // {
        //   text: "Mobile",
        //   value: "mobile",
        // },
        {
          text: "First Name",
          value: "first_name",
        },
        {
          text: "Last Name",
          value: "last_name",
        },
        {
          text: "Deactivate Dates",
          value: "deactivate_date",
        },
        {
          text: "Action",
          value: "saveDeactivateDateButton",
        },
      ];
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getAllDeactiveUserData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("checking machines=>", response.data.data);
          this.operatorsData = response.data.data;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    //
    save() {
      console.log("selectedItems", this.selectedItems);
      this.showLoader = true;
      this.dialog = false;

      let config = {
        method: "post",
        url: `${this.$config.backend_url}/DeletedeactiveUserData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: this.selectedItems,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          if (response.data.status == "S") {
            this.showLoader = false;
            document.querySelector("#sucessAlert").style.display = "block";
            setTimeout(function() {
              console.log("Delayed message after 3 seconds");
              document.querySelector("#sucessAlert").style.display = "None";
            }, 3000); // 3000 milliseconds = 3 seconds

            console.log("checking machines=>", response.data.data);
            this.menu = false;
            this.setGridData();
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
            this.menu = false;
          }
        });
    },

    saveDeactivateDate(item) {
      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/deactivateUserData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: item,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";

            this.showLoader = false;
            setTimeout(function() {
              console.log("Delayed message after 3 seconds");
              document.querySelector("#sucessAlert").style.display = "None";
            }, 3000); // 3000 milliseconds = 3 seconds

            console.log("checking machines=>", response.data.data);
            this.operatorsData = response.data.data;
            this.menu = false;
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
            this.menu = false;
          }
        });
    },
  },
};
</script>
<style scoped>
#sucessAlert {
  display: none;
}
#errorAlert {
  display: none;
}
</style>
